import type { OsasCloudPatExaminationCustomControlData } from '@common/validation/customControls/osas/osasCloudPatExaminationSchema';

export const initialData: OsasCloudPatExaminationCustomControlData = {
    assets: [],
    hasWarning: null,
    isFailed: false,
    studyIds: [],
};
